/* eslint-disable */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FieldArray, Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import { Form, Select } from 'formik-antd';
import { useDispatch } from 'react-redux';
import { capitalize, isEmpty } from 'lodash';
import moment from 'moment';
import { PoweroffOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { Box, FormInput, CustomInput, Button, Flex, Text } from 'atoms';
import { addUser, getPincodeList } from 'store/pageSlice';
import { Debug } from 'components/forms/Debug';
import { getClientList } from 'store/clientSlice';
import { ACL, BoxMod, EditModeBtn, ImageView } from 'components/common';
import { useQuery } from 'hooks';
import { validateMobileNumber } from './FormValidation';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import {
	intercityData,
	TripTypesOptions,
	vendorUserType,
	pdfimgformates,
	pdfimgfiletypetoShow,
} from 'utils/config';
import { CancelButton, DatePickers, ActionAddButton, ErrorMessageBox } from 'utils/commonStyled';
import {
	checkForNullDate,
	getLocalDate,
	getLocalTime,
	getServerFormatedDate,
	getServerFormatedDateV2,
	getuniqueArray,
	SVG,
} from 'utils';
import { getUserType } from 'hooks/useAuth';
// eslint-disable-next-line no-duplicate-imports
import { useAuth } from 'hooks';

const BoxSpace = styled(Box)`
	padding: 16px;
	margin-top: 12px;
	background: aliceblue;
`;
const FormButtonContainer = styled.div`
	width: 100%;
	position: fixed;
	bottom: 0;
	left: 0;
	display: flex;
	column-gap: 14px;
	padding: 16px 32px;
	background: white;
	justify-content: flex-end;
	z-index: 4;
`;
const FormPrimaryButton = styled.button`
	border: none;
	background-color: #143e60;
	width: 120px;
	padding: 4px 0;
	color: white;
	border-radius: 4px;
	cursor: pointer;
	pointer-events: all !important;
	&:disabled {
		background-color: #00000033;
		cursor: not-allowed;
	}
`;
const FormCancelButton = styled.button`
	background-color: white;
	border: 1px solid #ff3b30;
	color: #ff3b30;
	border-radius: 4px;
	width: 120px;
	padding: 4px 0;
	cursor: pointer;
	pointer-events: all !important;
`;
const mobileError = 'Must be exactly 10 digits';
const UOM = [
	{ label: 'Packet', value: 'pkt' },
	{ label: 'Boxes', value: 'bxs' },
	{ label: 'Bundle', value: 'bnd' },
	{ label: 'Carton', value: 'ctn' },
	{ label: 'Dozen', value: 'dzn' },
	{ label: 'Gross', value: 'grs' },
	{ label: 'Lot', value: 'lot' },
	{ label: 'Rack', value: 'rck' },
	{ label: 'Roll', value: 'rll' },
	{ label: 'Sheet', value: 'sht' },
];

function getTollData(shift) {
	return {
		amount: shift?.amount || undefined,
		toll_doc: shift?.toll_doc || undefined,
	};
}

function addRemoveToll(arrayHelpers, index) {
	// console.log(arrayHelpers, index);
	if (index === 0) {
		arrayHelpers.push(getTollData());
	} else {
		arrayHelpers.remove(index);
	}
}

function generateTollInfoData(shifts) {
	// console.log(shifts);
	return shifts?.map((item) => getTollData(item));
}
function getKMvalue(km) {
	// console.log(km);
	if (km) {
		return String(km);
	}
	return '';
}

function DateandTime(date, time) {
	return `${date} ${time}`;
}
export default function TripForm({
	isEditMode = false,
	formData,
	cities,
	tripData = [],
	trip_reason = [],
}) {
	const { permissions } = useAuth(); // get the user permissions
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const formRef = useRef();
	const [query] = useQuery();
	const cityType = query.get('city_type');
	const [step, setStep] = useState(0);
	const [projectData, setProjects] = useState('');
	const [driverData, setDriverdata] = useState('');
	const [vendorsData, setVendordata] = useState('');
	const [VehicleTypes, setVehicleTypes] = useState('');
	const [odometerStartFilesList, setOdometerStartFilesList] = useState([]);
	const [odometerEndFilesList, setOdometerEndFilesList] = useState([]);
	const [tripBreakdownFilesList, setTripBreakdownFilesList] = useState([]);
	const [requirementInfoFilesList, setRequirementProofFilesList] = useState([]);
	const [ProjectAdhocFlag, SetProjectAdhocFlag] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [isCreate, setIsCreate] = useState(false);

	// useEffect(() => {
	// 	console.log(ProjectAdhocFlag);
	// }, [ProjectAdhocFlag]);
	const validTripOptions = [
		{ value: true, label: 'Valid' },
		{ value: false, label: 'Invalid' },
	];

	const INVALID_TRIP_REASONS = [
		// eslint-disable-next-line sonarjs/no-duplicate-string
		{ value: 1, label: 'Wrong Data' },
		// eslint-disable-next-line sonarjs/no-duplicate-string
		{ value: 2, label: 'Client Disagreed' },
		{
			value: 3,
			label: 'Vehicle Not Reported',
		},
	];

	function checkuserType() {
		// console.log(getUserType());
		return !(getUserType() === 'supervisor');
	}
	const notSupervisor = checkuserType();
	// console.log(notSupervisor);

	useEffect(() => {
		setIsCreate(location.pathname.split('/').pop() === 'add');
	});
	const stepFormSchema = useMemo(
		() => [
			Yup.object({
				trip_type: Yup.string().required().label('Trip Type').required(),
				is_vendor_billed: Yup.boolean().label('Valid Trip'),
				is_valid: Yup.boolean().label('Valid Trip'),
				is_invalid_reason: Yup.number()
					.label('Trip Invalid reason')
					.when(['is_valid', 'end_date'], (is_valid, end_date, schema) => {
						if (!is_valid && isEditMode && end_date) {
							return schema
								.test(
									'is-invalid-reason-required',
									'Invalid reason is required',
									function (is_invalid_reason) {
										return is_invalid_reason !== 0;
									}
								)
								.required();
						}
						return schema;
					}),
				city: Yup.string().label('city').required(),
				project_id: Yup.string().required().label('Project'),
				vendor_id: Yup.string().required().label('Vendor name'),
				driver_id: Yup.string()
					.label('Driver name')
					.when('trip_type', (trip_type, schema) => {
						if (trip_type === 'regular') return schema.required();
						return schema;
					}),
				vehicle_number: Yup.string()
					.min(8)
					.max(12)
					.matches(
						/^(?:[0-9]{2}BH[0-9]{4}[A-Z]{1,2}|[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{1,4}|[A-Z]{2}[0-9]{4,8})$/,
						'Enter Valid Vehicle Number'
					)
					.required()
					.label('Vehicle Number'),
				reporting_date: Yup.date().required().label('Reporting Date'),
				start_date: Yup.date()
					.required()
					.label('Start Date')
					.when(
						'reporting_date',
						(reporting_date, yup) =>
							reporting_date &&
							yup.min(reporting_date, 'Start Date cannot be before Reporting Date')
					)
					.label('start Date'),
				end_date: Yup.date()
					.nullable()
					.label('End Date')
					.when(['start_date', 'trip_type'], {
						is: (start_date, trip_type) => start_date && trip_type === 'regular',
						then: (schema) =>
							schema
								.min(Yup.ref('start_date'), 'End Date cannot be before Start Date')
								.test('min-duration', function (end_date) {
									const { start_date } = this.parent;
									if (!start_date || !end_date) return true;
									const minEndDate = moment(start_date).add(2, 'hours');
									if (moment(end_date).isBefore(minEndDate)) {
										return this.createError({
											message: `End Time must be at least 2 hours ( ${minEndDate.format(
												'DD/MM/YYYY hh:mm A'
											)} ) from Start Time.`,
										});
									}
									return true;
								}),
						otherwise: (schema) =>
							schema.when('start_date', (start_date, yup) =>
								start_date
									? yup.min(start_date, 'End Date cannot be before Start Date')
									: yup
							),
					}),
				vehicle_type: Yup.string().required().label('Vehical Type'),
				driver_name: Yup.string().when('trip_type', (trip_type, schema) => {
					if (trip_type !== 'regular') return schema.required();
					return schema;
				}),
				driver_number: Yup.string()
					.label('Mobile Number')
					.min(10, mobileError)
					.max(10, mobileError)
					.when('trip_type', (trip_type, schema) => {
						if (trip_type !== 'regular') return schema.required();
						return schema;
					})
					.test('Not a valid Mobile Number', (value) => validateMobileNumber(value)),
				start_km: Yup.number()
					.label('start Km')
					.when('trip_type', (trip_type, schema) => {
						if (trip_type === 'regular') return schema.required();
						return schema;
					})
					.test('start-km-not-zero', 'Start KM should not be zero', function (start_km) {
						return start_km !== 0;
					}),
				end_km: Yup.number()
					.label('end Km')
					.when('trip_type', (trip_type, schema) => {
						if (trip_type === 'regular') return schema;
						return schema;
					})
					.test(
						'km-difference',
						'The difference between Start KM and End KM cannot exceed 250 KM. Please correct your entry.',
						function (end_km) {
							const { start_km } = this.parent;
							if (cityType === 'intra_city' && start_km && end_km) {
								return Math.abs(end_km - start_km) <= 250;
							}
							return true;
						}
					)
					.test(
						'start-end-km-equal',
						'Start KM and End KM cannot be the same without a valid reason. Please provide a reason to proceed.',
						function (end_km) {
							const { start_km, trip_end_reason } = this.parent;
							if (trip_end_reason) {
								return true;
							}
							if (start_km && end_km) {
								return start_km !== end_km;
							}
							return true;
						}
					)
					.test(
						'end-km-greater',
						'End KM should be greater than Start KM',
						function (end_km) {
							const { start_km } = this.parent;
							if (start_km && end_km) {
								return end_km >= start_km;
							}
							return true;
						}
					)
					.test('end-km-not-zero', 'End KM should not be zero', function (end_km) {
						return end_km !== 0;
					})
					.nullable(),
				prev_trip_id: Yup.string()
					.transform((value, originalValue) => {
						if (originalValue === null || originalValue === undefined) return null;
						if (typeof originalValue === 'string' && originalValue.trim() === '')
							return null;
						return String(originalValue).trim();
					})
					.nullable()
					.when('trip_type', (trip_type, schema) => {
						if (trip_type === 'replacement') {
							return schema.required('Previous Trip ID is required');
						}
						return schema;
					}),
				vendor_rate: Yup.number()
					.min(0)
					.when('trip_type', (trip_type, schema) => {
						if (trip_type === 'adhoc') return schema.required().min(1);
						return schema;
					}),
				client_rate: Yup.number()
					.min(0)
					.when('trip_type', (trip_type, schema) => {
						if (trip_type === 'adhoc') return schema.required();
						return schema;
					})
					.test(
						'is-greater',
						'Client rate must be greater than vendor rate',
						function (value) {
							const { vendor_rate, trip_type } = this.parent;
							if (trip_type === 'regular') return true;
							return value > vendor_rate;
						}
					),
				trip_end_reason: Yup.string().when(['end_km', 'start_km', 'trip_type'], {
					is: (end_km, start_km) => end_km && start_km && start_km === end_km,
					then: Yup.string().required().nullable(),
				}),
				trip_status: Yup.number(),
			}),
			Yup.object({
				goods_description: Yup.string().required().min(3).max(32).label('Good Description'),
				declared_value: Yup.number().required().label('Declared Value'),
				unit_count: Yup.number().label('Unit Count'),
				sender_address: Yup.string().required().min(3).max(200).label('Sender Address'),
				sender_name: Yup.string().required().min(3).max(128).label('Sender Name'),
				sender_pincode: Yup.string()
					.required('Pincode is required')
					.nullable()
					.min(6)
					.max(6)
					.label('Sender Pincode'),
				source_location: Yup.string().required().label('Source Location'),
				receiver_address: Yup.string().required().min(3).max(200).label('Receiver Address'),
				receiver_name: Yup.string().required().min(3).max(128).label('Receiver Name'),
				ewb_number: Yup.string()
					.min(12)
					.max(12)
					.matches(/^[0-9]*$/, 'Invalid EWB. Only Numbers Allowed.')
					.label('Ewb Number'),
				client_reference_numbers: Yup.array()
					.of(Yup.string().required('Client Reference Number is required'))
					.required('At least one Client Reference Number is required')
					.min(1, 'At least one Client Reference Number is required')
					.label('Client Reference Number'),
				receiver_pincode: Yup.string()
					.required('Pincode is required')
					.nullable()
					.min(6)
					.max(6)
					.label('Receiver Pincode'),
				destination_location: Yup.string().required().label('Destination Location'),
				gross_weight: Yup.number().required().label('Gross Weight'),
				goods_details: Yup.array().of(
					Yup.object().shape({
						goods_description: Yup.string()
							.required('Good Description is required')
							.label('Good Description'),
						goods_height: Yup.string().label('Goods Height'),
						goods_length: Yup.string().label('Goods Length'),
						goods_quantity: Yup.string()
							.required('Goods Quantity is required')
							.label('Goods Quantity'),
						goods_uom: Yup.string()
							.required('Goods UOM is required')
							.label('Goods UOM'),
						goods_weight: Yup.string().label('Goods Weight'),
						goods_width: Yup.string().label('Goods Width'),
					})
				),
			}),
			Yup.object({
				toll_info: Yup.array().of(
					Yup.object().shape({
						amount: Yup.number(),
						toll_doc: Yup.array(),
					})
				),
				requirement_proof: Yup.array()
					.label('Requirement Proof')
					.when('trip_type', (trip_type, schema) => {
						if (trip_type === 'adhoc' && isEmpty(requirementInfoFilesList))
							return schema.required();
						return schema;
					}),
			}),
		],
		[requirementInfoFilesList, isEditMode, cityType]
	);

	const initialValues = useMemo(
		() => ({
			trip_approval_status: formData?.trip_approval_status || undefined,
			is_approved: formData?.is_approved || undefined,
			trip_type: formData?.trip_type
				? formData?.trip_type
				: cityType === 'inter_city'
				? 'adhoc'
				: undefined,
			is_valid: formData?.is_valid || false,
			is_invalid_reason: isEditMode
				? formData?.is_invalid_reason
					? formData?.is_invalid_reason === 0
						? ''
						: formData?.is_invalid_reason
					: ''
				: '',
			is_vendor_billed: formData?.is_vendor_billed || false,
			city: formData?.city || undefined,
			project_id: formData?.project_id || undefined,
			project_name: formData?.project_location_code || undefined,
			vendor_id: formData?.vendor_id || undefined,
			vendor_name: formData?.vendor_name || undefined,
			driver_id: formData?.driver_id || undefined,
			driver_name_view:
				((formData?.driver_username || formData?.driver_name) &&
					`${formData?.driver_username} ${formData.driver_name}`) ||
				undefined,
			vehicle_number: formData?.vehicle_number || undefined,
			reporting_date: isEditMode
				? formData?.reporting_time
					? moment(formData.reporting_time, 'MM/DD/YYYY HH:mm:ss').toDate()
					: undefined
				: undefined,
			start_date: isEditMode
				? formData?.start_time
					? moment(formData.start_time, 'MM/DD/YYYY HH:mm:ss').toDate()
					: undefined
				: undefined,
			end_date: isEditMode
				? formData?.end_time
					? checkForNullDate(formData?.end_time)
					: null
				: undefined,
			start_km: isEditMode ? getKMvalue(formData?.start_km) : '',
			end_km: isEditMode ? getKMvalue(formData?.end_km) : null,
			vehicle_type: formData?.vehicle_type || undefined,
			trip_documents: formData?.trip_documents || undefined,
			vendor_type: formData?.vendor_type || undefined,
			prev_trip_id: formData?.info?.prev_trip_id || undefined,
			adhoc_reason: formData?.info?.adhoc_reason || undefined,
			vendor_rate: formData?.vendor_trip_cost || undefined,
			client_rate: formData?.client_trip_cost || undefined,
			driver_name: formData?.info?.driver_name || undefined,
			driver_number: formData?.info?.driver_number || undefined,
			is_inter_city:
				formData?.info?.is_inter_city || cityType === 'inter_city' ? true : false,
			requirement_proof: isEditMode
				? formData?.info?.requirement_proof
				: getRequirementFiles(),
			toll_info: !isEmpty(formData?.toll_info)
				? generateTollInfoData(formData?.toll_info)
				: [getTollData()],
			sender_address: formData?.sender_address || undefined,
			sender_name: formData?.sender_name || undefined,
			sender_pincode: formData?.sender_pincode || undefined,
			source_location: formData?.source_location || undefined,
			receiver_address: formData?.receiver_address || undefined,
			receiver_name: formData?.receiver_name || undefined,
			receiver_pincode: formData?.receiver_pincode,
			destination_location: formData?.destination_location || undefined,
			client_reference_numbers: formData?.client_reference_numbers || [],
			ewb_number: formData?.ewb_number || undefined,
			gross_weight: formData?.gross_weight || undefined,
			unit_count: formData?.unit_count || undefined,
			goods_description: formData?.goods_description || undefined,
			declared_value: formData?.declared_value || undefined,
			goods_details: formData?.goods_details || [
				{
					goods_description: '',
					goods_height: '',
					goods_length: '',
					goods_quantity: '',
					goods_uom: '',
					goods_weight: '',
					goods_width: '',
				},
			],
			trip_end_reason: formData?.trip_end_reason || undefined,
			trip_status: formData?.trip_status || undefined,
			audited_at: formData?.audited_at || undefined,
			audited_by_name: formData?.audited_by_name || undefined,
			audit_remarks: formData?.audit_remarks || undefined,
			remarks: formData?.remarks || formData?.info?.remarks || '',
			pod_status: formData?.pod_status || false,
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[formData, isEditMode, cityType]
	);

	function useOnceCall(cb, condition = true) {
		const isCalledRef = useRef(false);

		useEffect(() => {
			if (condition && !isCalledRef.current) {
				isCalledRef.current = true;
				cb();
			}
		}, [cb, condition]);
	}

	useOnceCall(() => {
		/**
		 * On Edit mode prefill dropdowns of zones, states, cites, client_ids
		 */
		handleCitiesChange(formData?.city);
		handleProjectChange(formData?.project_id, '', formData);
		getVendorDataList();
		if (permissions?.search?.includes('driver') || permissions?.search?.includes('all')) {
			dispatch(
				getClientList({
					search_type: 'driver',
					filter_by: {},
				})
			).then((res) => {
				const data = res?.data?.map((item) => ({
					value: item?.id,
					label: `${item?.username} ${item?.driver_name}`,
					item,
				}));
				setDriverdata(data);
			});
		}
	});
	//
	function getRequirementFiles() {
		if (!isEmpty(requirementInfoFilesList)) {
			return requirementInfoFilesList;
		}
		return undefined;
	}

	const DisplayBIlledMsg = styled(Box)`
		text-align: center;
		background: #ccc;
		padding: 10px;
		color: #0fa90f;
		line-height: 2;
	`;
	const DisplayAhcdMsg = styled(Box)`
		background: #f8ec42;
		padding: 10px 40px;
		color: #858b85;
		line-height: 2;
		margin-top: 12px;
	`;

	function handleProjectChange(e, setFieldValue, values) {
		if (setFieldValue) {
			setFieldValue('vehicle_type', undefined);
			setFieldValue('driver_id', undefined);
			setFieldValue('vendor_id', undefined);
		}
		if (
			values.trip_type === 'regular' &&
			(permissions?.search?.includes('vendor_contract') ||
				permissions?.search?.includes('all'))
		) {
			dispatch(
				getClientList({
					search_type: 'vendor_contract',
					filter_by: {
						project_id: e,
						city: values?.city,
						is_active: true,
					},
				})
			).then((res) => {
				const data_vendor = res?.data?.map((item) => ({
					value: item?.vendor_id,
					label: item?.vendor_name,
				}));
				const data_vechicleType = res?.data?.map((item) => ({
					value: item?.vehicle_type,
					label: item?.vehicle_type,
				}));

				setVehicleTypes(getuniqueArray(data_vechicleType));
				setVendordata(getuniqueArray(data_vendor));
			});
		}
		if (
			values.trip_type === 'adhoc' &&
			(permissions?.search?.includes('project') || permissions?.search?.includes('all'))
		) {
			getVehicleTypes();

			dispatch(
				getClientList({
					search_type: 'project',
					filter_by: {
						id: e,
						is_active: true,
					},
				})
			).then((pro_res) => {
				// console.log(pro_res);
				const proFalg = pro_res?.data?.map((item) => ({
					adhoc_approval_required: item?.adhoc_approval_required,
				}));
				// console.log(proFalg);
				if (proFalg) {
					SetProjectAdhocFlag(proFalg[0]?.adhoc_approval_required);
				}
			});
		}
	}

	function handleVendorsChange(e, setFieldValue) {
		if (setFieldValue) {
			setFieldValue('vehicle_type', undefined);
			setFieldValue('driver_id', undefined);
		}
	}

	function handleInvalidTripReason(e, setFieldValue) {
		if (setFieldValue) {
			setFieldValue('Wrong Data', undefined);
			setFieldValue('Client Disagreed', undefined);
			setFieldValue('Vehicle Not Reported', undefined);
		}
	}

	function handleVehicleTypeChange(e, setFieldValue, values) {
		if (setFieldValue) {
			setFieldValue('driver_id', undefined);
		}
		if (
			values.trip_type === 'regular' &&
			(permissions?.search?.includes('driver') || permissions?.search?.includes('all'))
		) {
			dispatch(
				getClientList({
					search_type: 'driver',
					filter_by: {
						vehicle_type: e,
						vendor_id: values?.vendor_id,
					},
				})
			).then((res) => {
				const data = res?.data?.map((item) => ({
					value: item?.id,
					label: `${item?.driver_name} -${item?.username}`,
					item,
				}));
				setDriverdata(data);
			});
		}
	}

	function handleCitiesChange(e, setFieldValue) {
		if (setFieldValue) {
			setFieldValue('vendor_type', undefined);
			setFieldValue('project_id', undefined);
			setFieldValue('vehicle_type', undefined);
			setFieldValue('driver_id', undefined);
			setFieldValue('vendor_id', undefined);
		}

		if (permissions?.search?.includes('project') || permissions?.search?.includes('all')) {
			dispatch(
				getClientList({
					search_type: 'project',
					filter_by: {
						city: e,
						is_active: true,
					},
				})
			).then((pro_res) => {
				// console.log(pro_res);
				const prodata = pro_res?.data?.map((item) => ({
					label: capitalize(item?.project_location_code),
					value: item?.id,
					id: item?.id,
					project_loc_codes: item?.project_location_code,
					item,
				}));
				setProjects(prodata);
			});
		}
	}

	function getVendorDataList(type) {
		if (permissions?.search?.includes('vendor') || permissions?.search?.includes('all')) {
			if (type) {
				dispatch(
					getClientList({
						search_type: 'vendor',
						filter_by: {
							is_active: true,
							vendor_type: type,
						},
					})
				).then((res) => {
					let data_vendor = [];
					data_vendor = res?.data?.map((item) => ({
						value: item?.id,
						label: item?.vendor_info?.vendor_name,
					}));

					setVendordata(getuniqueArray(data_vendor));
				});
			} else {
				dispatch(
					getClientList({
						search_type: 'vendor',
						filter_by: {
							is_active: true,
						},
					})
				).then((res) => {
					let data_vendor = [];
					data_vendor = res?.data?.map((item) => ({
						value: item?.id,
						label: item?.vendor_info?.vendor_name,
					}));
					setVendordata(getuniqueArray(data_vendor));
				});
			}
		}
	}

	function getVehicleTypes() {
		if (permissions?.search?.includes('vehicle') || permissions?.search?.includes('all')) {
			dispatch(
				getClientList({
					search_type: 'vehicle',
					filter_by: {},
				})
			).then((resVehical) => {
				// console.log(resVehical);
				const data_vechicleType = resVehical?.data?.map((item) => ({
					value: item?.vehicle_type,
					label: item?.vehicle_type,
				}));

				setVehicleTypes(getuniqueArray(data_vechicleType));
			});
		}
	}

	function handleVendorTypeChange(e, setFieldValue, values) {
		// console.log(e, setFieldValue);
		if (setFieldValue) {
			setFieldValue('project_id', undefined);
			setFieldValue('vehicle_type', undefined);
			setFieldValue('driver_id', undefined);
			setFieldValue('vendor_id', undefined);
		}
		getVehicleTypes();
		if (values.trip_type === 'adhoc') {
			getVendorDataList(e);
		}
	}

	function handleTripTypeChange(e, setFieldValue) {
		if (cityType === 'inter_city') {
			return;
		}
		if (setFieldValue) {
			setFieldValue('project_id', undefined);
			setFieldValue('vehicle_type', undefined);
			setFieldValue('driver_id', undefined);
			setFieldValue('vendor_id', undefined);
			setFieldValue('city', undefined);
		}
	}

	function handlePincodeChange(pincode, setFieldValue, role) {
		const pin_code = pincode;

		if (pin_code?.length === 6) {
			if (role == 'receiver') {
				setFieldValue('receiver_pincode', pin_code);

				dispatch(getPincodeList(pin_code)).then((res) => {
					const { city, state, zone } = res?.rows?.[0] || {};
					if (city && state) {
						const destination = `${city}, ${state}`;
						setFieldValue('destination_location', destination);
					}
				});
			}
			if (role == 'sender') {
				setFieldValue('sender_pincode', pin_code);

				dispatch(getPincodeList(pin_code)).then((res) => {
					const { city, state, zone } = res?.rows?.[0] || {};
					if (city && state) {
						const destination = `${city}, ${state}`;
						setFieldValue('source_location', destination);
					}
				});
			}
		}
	}

	function getRatets(value) {
		if (Number(value) === 0) {
			return Number(0);
		}
		if (parseFloat(value) > 0) {
			return parseFloat(value);
		}
		return undefined;
	}

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		const {
			reporting_date,
			start_date,
			end_date,
			start_km,
			end_km,
			prev_trip_id,
			adhoc_reason,
			client_rate,
			vendor_rate,
			is_inter_city,
			requirement_proof,
			driver_name,
			driver_number,
			vehicle_type,
			vehicle_number,
			trip_end_reason,
			toll_info,
			...rest
		} = values;

		const trip_info = {
			prev_trip_id: values.trip_type === 'replacement' ? prev_trip_id : undefined,
			adhoc_reason,
			client_rate: getRatets(client_rate),
			vendor_rate: getRatets(vendor_rate),
			is_inter_city,
			driver_name,
			driver_number,
			requirement_proof: !isEmpty(requirementInfoFilesList)
				? requirementInfoFilesList
				: requirement_proof,
		};

		const { reporting_date_payload, reporting_time_payload } = getServerFormatedDateV2(
			reporting_date,
			'reporting_date'
		);

		const { start_date_payload, start_time_payload } = getServerFormatedDateV2(
			start_date,
			'start_date'
		);

		const { end_date_payload, end_time_payload } = getServerFormatedDate(end_date, 'end_date');

		// if (!isEmpty(toll_info)) {
		// 	for (let i = 0; i < toll_info.length; i += 1) {
		// 		if (toll_info[i].amount) {
		// 			toll_info[i].amount = Number(toll_info[i].amount);
		// 		}
		// 	}
		// }

		if (!isEmpty(toll_info)) {
			// eslint-disable-next-line no-restricted-syntax
			for (const i in toll_info) {
				if (toll_info[i].amount) {
					toll_info[i].amount = Number(toll_info[i].amount);
				}
			}
		}

		// console.log(toll_info);
		const payload = {
			data: {
				...rest,
				vehicle_type: isEditMode ? formData?.vehicle_type : values.vehicle_type,
				id: isEditMode ? formData.id : undefined,
				vehicle_number: vehicle_number.toUpperCase(),
				trip_end_reason: start_km === end_km ? trip_end_reason : '',
				reporting_time: DateandTime(reporting_date_payload, reporting_time_payload),
				start_date: DateandTime(start_date_payload, start_time_payload),
				end_date: end_date_payload ? end_date_payload : null,
				end_time:
					end_date_payload && end_time_payload
						? DateandTime(end_date_payload, end_time_payload)
						: null,
				is_active: true,
				start_km: Number(start_km),
				end_km: end_km ? Number(end_km) : null,
				info: trip_info,
				trip_documents: {
					odometer_start: !isEmpty(odometerStartFilesList)
						? odometerStartFilesList
						: formData?.trip_documents?.odometer_start,
					odometer_end: !isEmpty(odometerEndFilesList)
						? odometerEndFilesList
						: formData?.trip_documents?.odometer_end,
					trip_breakdown: !isEmpty(tripBreakdownFilesList)
						? tripBreakdownFilesList
						: formData?.trip_documents?.trip_breakdown,
				},
				toll_info,
			},
		};

		if (isEditMode) {
			payload.update_type = 'trip';
		} else {
			payload.create_type = 'trip';
		}
		dispatch(addUser({ data: payload, setErrors, isEditMode }))
			.then(() => {
				setSubmitting(false);
				if (isEditMode) {
					message.success('Trip updated successfully');
				} else {
					message.success('Trip created successfully');
				}
				navigate(-1);
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handleOdometerStartFileUpload(files) {
		// console.log('handleOdometerStartFileUpload', files);
		setOdometerStartFilesList(files);
	}
	function handleOdometerEndFileUpload(files) {
		// console.log('handleOdometerEndFileUpload', files);
		setOdometerEndFilesList(files);
	}
	function handleTripBreakdownFileUpload(files) {
		// console.log('handleTripBreakdownFileUpload', files);
		setTripBreakdownFilesList(files);
	}
	function handleTollInfoFileUpload(res) {
		const { files, extraParams } = res;
		if (!isEmpty(extraParams)) {
			const [index, setFieldValue] = extraParams;
			setFieldValue(`toll_info[${index}].toll_doc`, files);
		}
	}

	function handleRequirementProofFileUpload(files) {
		// console.log('handleRequirementProofFileUpload', files);
		setRequirementProofFilesList(files);
		// console.log('formRef', formRef);
		if (formRef?.current) {
			// console.log('inside');
			formRef.current?.setFieldValue('requirement_proof', files);
		} else {
			formRef.current?.setFieldValue('requirement_proof', undefined);
		}
	}

	function getValidType(valid) {
		// console.log(valid);
		// eslint-disable-next-line no-unneeded-ternary
		return valid === true ? true : false;
	}

	const apps = {
		padding: '15px 43px',
		textAlign: 'center',
		maxWidth: '22%',
		marginTop: '15px',
	};
	const appsPending = {
		padding: '15px 43px',
		textAlign: 'center',
		marginTop: '15px',
	};
	const Autoapps = {
		padding: '15px 43px',
		textAlign: 'center',
		maxWidth: '42%',
		marginTop: '15px',
	};
	const rejectapps = {
		padding: '15px 43px',
		textAlign: 'left',
		marginTop: '15px',
		lineHeight: '2',
	};
	const approvedS = {
		color: 'green',
		fontSize: '21px',
	};
	const approvedSpending = {
		color: '#e66119',
		fontSize: '21px',
	};
	const rejectedS = {
		color: 'red',
		fontSize: '21px',
	};

	const overlaps = {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		textAlign: 'left',
	};

	// values?.trip_approval_status === 1
	const stepFormFields = [
		({ values, errors, setFieldValue }) => (
			<Box padding="1.5rem 2rem" background="#fff">
				<Row gutter={16} justify="space-between">
					<Col lg={12}>
						<FormInput name="trip_type" label="Trip Type *">
							<Select
								disabled={isEditMode || cityType === 'inter_city'}
								name="trip_type"
								filterOption={(input, option) =>
									option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
								options={TripTypesOptions}
								placeholder="Select"
								onChange={(e) => handleTripTypeChange(e, setFieldValue)}
							/>
						</FormInput>
					</Col>
					<Col lg={12}>
						<FormInput name="city" label="City *">
							<Select
								name="city"
								showSearch
								disabled={isEditMode}
								onClear
								filterOption={(input, option) =>
									option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
								options={cities}
								placeholder="Select"
								onChange={(e) => handleCitiesChange(e, setFieldValue)}
							/>
						</FormInput>
					</Col>
				</Row>
				<Row gutter={16} justify="space-between">
					<Col lg={12}>
						<FormInput name="reporting_date" label="Reporting Date *">
							<DatePickers
								name="reporting_date"
								showTime
								format="YYYY-MM-DD h:mm A"
								disabledDate={(current) =>
									current.isAfter(moment().subtract(0, 'day'))
								}
							/>
						</FormInput>
					</Col>
					<Col lg={12}>
						<FormInput name="start_date" label="Start Date *">
							<DatePickers
								name="start_date"
								showTime
								format="YYYY-MM-DD h:mm A"
								disabledDate={(current) =>
									current.isAfter(moment().subtract(0, 'day'))
								}
							/>
						</FormInput>
					</Col>
				</Row>
				<Row gutter={16} justify="space-between">
					<Col lg={12}>
						<FormInput name="end_date" label="End Date ">
							<DatePickers
								name="end_date"
								showTime
								format="YYYY-MM-DD h:mm A"
								disabledDate={(current) =>
									current.isAfter(moment().subtract(0, 'day'))
								}
							/>
						</FormInput>
					</Col>
					<Col lg={12}>
						{values?.trip_status === 3 && isEditMode && notSupervisor && (
							<FormInput name="is_valid" label="Valid Trip *">
								<Select
									name="is_valid"
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									disabled={getValidType(values?.is_vendor_billed)}
									placeholder="Select"
									options={validTripOptions}
								/>
							</FormInput>
						)}
					</Col>
				</Row>
				{isEditMode && !values.is_valid && (
					<Row gutter={16} justify="space-between">
						<Col lg={12}>
							<FormInput name="is_invalid_reason" label="Invalid Reason *">
								<Select
									name="is_invalid_reason"
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									placeholder="Select"
									options={INVALID_TRIP_REASONS}
									onChange={(e) => handleInvalidTripReason(e, setFieldValue)}
								/>
							</FormInput>
						</Col>
					</Row>
				)}
				<Row gutter={16} justify="space-between">
					<Col lg={12}>
						<FormInput
							name="start_km"
							label={
								values.trip_type === 'adhoc' && cityType == 'inter_city'
									? 'Start KM '
									: 'Start KM *'
							}
						>
							<CustomInput name="start_km" />
						</FormInput>
					</Col>
					<Col lg={12}>
						<FormInput name="end_km" label="End KM ">
							<CustomInput name="end_km" />
						</FormInput>
					</Col>
				</Row>
				{values?.start_km > 0 && values?.start_km === values?.end_km && (
					<Row gutter={16} justify="space-between">
						<Col lg={12}>
							<FormInput name="trip_end_reason" label="Trip end Reason *">
								<Select
									name="trip_end_reason"
									showSearch
									onClear
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									placeholder="Select"
									options={trip_reason}
								/>
							</FormInput>
						</Col>
					</Row>
				)}
				{values.trip_type === 'adhoc' && (
					<Row gutter={16} justify="space-between">
						<Col lg={12}>
							<FormInput name="vendor_type" label="Vendor Type *">
								<Select
									name="vendor_type"
									showSearch
									onClear
									disabled={isEditMode}
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									options={vendorUserType}
									placeholder="Select"
									onChange={(e) =>
										handleVendorTypeChange(e, setFieldValue, values)
									}
								/>
							</FormInput>
						</Col>
					</Row>
				)}
				<Row gutter={16} justify="space-between">
					<Col lg={12}>
						{!isEditMode ? (
							<FormInput name="project_id" label="Select Project *">
								<Select
									name="project_id"
									showSearch
									onClear
									disabled={isEditMode}
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									options={projectData}
									placeholder="Select"
									onChange={(e) => handleProjectChange(e, setFieldValue, values)}
								/>
							</FormInput>
						) : (
							<FormInput name="project_name" label="Select Project *">
								<CustomInput disabled name="project_name" />
							</FormInput>
						)}
					</Col>
					<Col lg={12}>
						{!isEditMode ? (
							<FormInput name="vendor_id" label="Select Vendor *">
								<Select
									name="vendor_id"
									showSearch
									disabled={isEditMode}
									onClear
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									options={vendorsData}
									placeholder="Select"
									onChange={(e) => handleVendorsChange(e, setFieldValue)}
								/>
							</FormInput>
						) : (
							<FormInput name="vendor_name" label="Select Vendor *">
								<CustomInput disabled name="vendor_name" />
							</FormInput>
						)}
					</Col>
				</Row>
				<Row gutter={16} justify="space-between">
					<Col lg={12}>
						<FormInput name="vehicle_type" label="Vehical Type *">
							<Select
								showSearch
								onClear
								name="vehicle_type"
								disabled={isEditMode}
								filterOption={(input, option) =>
									option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
								options={VehicleTypes}
								placeholder="Select"
								onChange={(e) => handleVehicleTypeChange(e, setFieldValue, values)}
							/>
						</FormInput>
					</Col>
					<Col lg={12}>
						{values.trip_type === 'regular' &&
							(!isEditMode ? (
								<FormInput name="driver_id" label="Driver *">
									<Select
										showSearch
										onClear
										name="driver_id"
										disabled={isEditMode}
										filterOption={(input, option) =>
											option.label
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
										}
										placeholder="Select"
										options={driverData}
									/>
								</FormInput>
							) : (
								<FormInput name="driver_name_view" label="Driver *">
									<CustomInput disabled name="driver_name_view" />
								</FormInput>
							))}
						{values.trip_type === 'adhoc' && (
							<FormInput name="adhoc_reason" label="Adhoc Reason *">
								<CustomInput
									name="adhoc_reason"
									disabled
									value="Extra reqirement"
								/>
							</FormInput>
						)}
					</Col>
				</Row>
				<Row gutter={16} justify="space-between">
					<Col lg={12}>
						<FormInput name="vehicle_number" label="Vehicle No *">
							<CustomInput name="vehicle_number" isCaps />
						</FormInput>
					</Col>
					{values.trip_type === 'replacement' && (
						<Col lg={12}>
							<FormInput name="prev_trip_id" label="Previous Trip ID *">
								<Select
									name="prev_trip_id"
									showSearch
									disabled={isEditMode}
									onClear
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									placeholder="Select"
									options={tripData}
								/>
							</FormInput>
						</Col>
					)}
					{/* {values.trip_type === 'adhoc' && (
						<Col lg={12}>
							<FormInput name="is_inter_city" label="Inter City *">
								<Select
									name="is_inter_city"
									showSearch
									onClear
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									placeholder="Select"
									options={intercityData}
								/>
							</FormInput>
						</Col>
					)} */}
				</Row>
				{(values?.trip_status === 3 || values.trip_type === 'adhoc') && (
					<Row gutter={16} justify="space-between">
						<Col lg={12}>
							<FormInput name="vendor_rate" label="Vendor Rate *">
								<CustomInput
									disabled={values.trip_type === 'regular'}
									name="vendor_rate"
								/>
							</FormInput>
						</Col>
						<Col lg={12}>
							<FormInput name="client_rate" label="Client Rate *">
								<CustomInput
									disabled={values.trip_type === 'regular'}
									name="client_rate"
								/>
							</FormInput>
						</Col>
					</Row>
				)}
				{values.trip_type === 'adhoc' && (
					<Row gutter={16} justify="space-between">
						<Col lg={12}>
							<FormInput name="driver_name" label="Driver Name *">
								<CustomInput name="driver_name" />
							</FormInput>
						</Col>
						<Col lg={12}>
							<FormInput name="driver_number" label="Driver Number *">
								<CustomInput name="driver_number" />
							</FormInput>
						</Col>
					</Row>
				)}
				{values.trip_type === 'adhoc' && (
					<Row gutter={16} justify="space-between">
						<Col lg={24}>
							<FormInput name="remarks" label="Remarks">
								<CustomInput
									name="remarks"
									disabled={!editMode && isEditMode}
									placeholder="Enter remarks"
								/>
							</FormInput>
						</Col>
					</Row>
				)}
			</Box>
		),
		({ values, errors, setFieldValue }) => (
			<Box padding="1.5rem 2rem" background="#fff">
				<Row gutter={32} style={{ marginBottom: '16px' }}>
					<Col lg={12} style={{ textAlign: 'center' }}>
						<Box style={{ border: '1px solid #C6C6C8', padding: '10px' }}>
							<h3 style={{ fontWeight: 'bold', fontSize: '24px', padding: '10px' }}>
								Goods Summary
							</h3>
							<Row gutter={24}>
								<Col lg={12}>
									<FormInput
										name="goods_description"
										label="Description of Goods*"
									>
										<CustomInput
											name="goods_description"
											placeholder="Description"
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="declared_value" label="Declared Value*">
										<CustomInput
											name="declared_value"
											placeholder="Declared Value"
											isCaps
											type="number"
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col lg={12}>
									<FormInput name="gross_weight" label="Gross Weight*">
										<CustomInput
											name="gross_weight"
											placeholder="Gross Weight in Ton"
											isCaps
											type="number"
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="unit_count" label="Unit Count">
										<CustomInput
											name="unit_count"
											placeholder="Declared Value"
											isCaps
											type="number"
										/>
									</FormInput>
								</Col>
							</Row>
						</Box>
					</Col>
					<Col
						lg={12}
						style={{
							textAlign: 'center',
							justifyContent: 'flex-start',
						}}
					>
						<Box style={{ border: '1px solid #C6C6C8', padding: '10px' }}>
							<h3
								style={{
									fontWeight: 'bold',
									fontSize: '24px',
									paddingInline: '10px',
								}}
							>
								Reference
							</h3>
							<FieldArray
								name="client_reference_numbers"
								render={({ remove, push }) => {
									const maxVisible = 6;
									const tags = values.client_reference_numbers || [];
									const visibleTags = tags.slice(0, maxVisible);
									const hiddenCount = tags.length - maxVisible;
									return (
										<>
											<div
												style={{
													display: 'flex',
													gap: 8,
													marginBottom: 12,
												}}
											>
												<input
													type="text"
													value={values._refInput || ''}
													placeholder="Reference Number"
													style={{
														flex: 1,
														padding: '8px',
														border: '1px solid #C6C6C8',
														borderRadius: 4,
													}}
													onChange={(e) =>
														setFieldValue('_refInput', e.target.value)
													}
													onKeyDown={(e) => {
														if (
															e.key === 'Enter' &&
															values._refInput?.trim()
														) {
															if (
																!tags.includes(
																	values._refInput.trim()
																)
															) {
																push(values._refInput.trim());
															}
															setFieldValue('_refInput', '');
														}
													}}
												/>
												<button
													type="button"
													style={{
														background: '#143e60',
														color: 'white',
														border: 'none',
														borderRadius: 4,
														padding: '0 24px',
														height: 40,
														fontWeight: 500,
														cursor: 'pointer',
													}}
													onClick={() => {
														if (values._refInput?.trim()) {
															if (
																!tags.includes(
																	values._refInput.trim()
																)
															) {
																push(values._refInput.trim());
															}
															setFieldValue('_refInput', '');
														}
													}}
												>
													Add
												</button>
											</div>
											<div
												style={{
													display: 'flex',
													overflowX: 'auto',
													gap: 8,
													padding: 4,
													border: '1px solid #C6C6C8',
													borderRadius: 4,
													background: '#fff',
													marginBottom: 12,
													minHeight: 44,
													alignItems: 'center',
													scrollbarWidth: 'none',
													msOverflowStyle: 'none',
													'&::-webkit-scrollbar': {
														display: 'none',
													},
												}}
												className="reference-tag-scroll"
											>
												{(values.client_reference_numbers || []).map(
													(tag, idx) =>
														tag !== '' && (
															<span
																key={idx}
																style={{
																	display: 'inline-flex',
																	alignItems: 'center',
																	background: '#fff',
																	border: '1px solid #143e60',
																	color: '#143e60',
																	borderRadius: 10,
																	padding: '4px 12px',
																	fontSize: 14,
																	marginRight: 0,
																	whiteSpace: 'nowrap',
																	fontWeight: 500,
																}}
															>
																{tag}
																<span
																	style={{
																		marginLeft: 8,
																		cursor: 'pointer',
																		fontWeight: 'bold',
																	}}
																	onClick={() => remove(idx)}
																>
																	×
																</span>
															</span>
														)
												)}
											</div>
											<style>{`
												.reference-tag-scroll::-webkit-scrollbar {
													display: none;
												}
												.reference-tag-scroll {
													-ms-overflow-style: none;  /* IE and Edge */
													scrollbar-width: none;  /* Firefox */
												}
											`}</style>
											{errors.client_reference_numbers &&
												(!tags.length ||
													tags.every((tag) => !tag.trim())) && (
													<div
														style={{
															color: 'red',
															marginTop: '-10px',
															marginBottom: '10px',
														}}
													>
														{typeof errors.client_reference_numbers ===
														'string'
															? errors.client_reference_numbers
															: 'At least one Client Reference Number is required'}
													</div>
												)}
										</>
									);
								}}
							/>
							<Row gutter={24} style={{ marginTop: 8 }}>
								<Col lg={24}>
									<FormInput name="ewb_number" label="EWay Bill No.">
										<CustomInput
											name="ewb_number"
											placeholder="EWay Bill No."
											isCaps
											disabled={isEditMode && values.pod_status}
										/>
									</FormInput>
								</Col>
							</Row>
						</Box>
					</Col>
				</Row>
				<Row gutter={32} style={{ marginBottom: '16px' }}>
					<Col lg={12} style={{ textAlign: 'center' }}>
						<Box
							style={{
								border: '1px solid #C6C6C8',
								padding: '10px',
								backgroundColor: '#EFF8FF',
							}}
						>
							<h3 style={{ fontWeight: 'bold', fontSize: '24px', padding: '10px' }}>
								Sender
							</h3>
							<Row gutter={24}>
								<Col lg={24}>
									<FormInput name="sender_name" label="Name*">
										<CustomInput name="sender_name" placeholder="Name" />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col lg={24}>
									<FormInput name="sender_address" label="Address*">
										<CustomInput name="sender_address" placeholder="Address" />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col lg={12}>
									<FormInput name="sender_pincode" label="Pincode*">
										<CustomInput
											name="sender_pincode"
											placeholder="Pincode"
											isCaps
											onChange={(e) =>
												handlePincodeChange(
													e.target.value,
													setFieldValue,
													'sender'
												)
											}
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="source_location" label="Destination*">
										<CustomInput
											name="source_location"
											placeholder="Destination"
											disabled
										/>
									</FormInput>
								</Col>
							</Row>
						</Box>
					</Col>
					<Col lg={12} style={{ textAlign: 'center' }}>
						<Box
							style={{
								border: '1px solid #C6C6C8',
								padding: '10px',
								backgroundColor: '#EFF8FF',
							}}
						>
							<h3 style={{ fontWeight: 'bold', fontSize: '24px', padding: '10px' }}>
								Receiver
							</h3>
							<Row gutter={24}>
								<Col lg={24}>
									<FormInput name="receiver_name" label="Name*">
										<CustomInput name="receiver_name" placeholder="Name" />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col lg={24}>
									<FormInput name="receiver_address" label="Address*">
										<CustomInput
											name="receiver_address"
											placeholder="Address"
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col lg={12}>
									<FormInput name="receiver_pincode" label="Pincode*">
										<CustomInput
											name="receiver_pincode"
											placeholder="Pincode"
											isCaps
											onChange={(e) =>
												handlePincodeChange(
													e.target.value,
													setFieldValue,
													'receiver'
												)
											}
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="destination_location" label="Destination*">
										<CustomInput
											name="destination_location"
											placeholder="Destination"
											disabled
										/>
									</FormInput>
								</Col>
							</Row>
						</Box>
					</Col>
				</Row>
				<FieldArray
					name="goods_details"
					render={({ remove, push }) => (
						<>
							{values.goods_details?.map((goods_details, index) => (
								<Row gutter={32} style={{ marginBottom: '16px' }} key={index}>
									<Col lg={24} style={{ textAlign: 'center' }}>
										<Box
											style={{
												border: '1px solid #C6C6C8',
												padding: '10px',
												backgroundColor: '#EFF8FF',
											}}
										>
											<h3
												style={{
													fontWeight: 'bold',
													fontSize: '24px',
													padding: '10px',
												}}
											>
												Goods Details
											</h3>
											<Row gutter={24}>
												<Col lg={12}>
													<FormInput
														name={`goods_details[${index}].goods_description`}
														label="Description*"
														labelCol={{ span: 9.5 }}
														wrapperCol={{ span: 14.5 }}
													>
														<CustomInput
															name={`goods_details[${index}].goods_description`}
															placeholder="Description"
														/>
													</FormInput>
												</Col>
												<Col lg={6}>
													<FormInput
														name={`goods_details[${index}].goods_quantity`}
														label="Quantity*"
														labelCol={{ span: 8 }}
														wrapperCol={{ span: 16 }}
													>
														<CustomInput
															type="number"
															name={`goods_details[${index}].goods_quantity`}
															placeholder="Quantity"
															isCaps
														/>
													</FormInput>
												</Col>
												<Col lg={6}>
													<FormInput
														name={`goods_details[${index}].goods_uom`}
														label="UOM*"
														labelCol={{ span: 8 }}
														wrapperCol={{ span: 16 }}
													>
														<Select
															name={`goods_details[${index}].goods_uom`}
															showSearch
															filterOption={(input, option) =>
																option.label
																	.toLowerCase()
																	.indexOf(input.toLowerCase()) >=
																0
															}
															options={UOM}
															placeholder="UOM"
															style={{ width: '100%' }}
														/>
													</FormInput>
												</Col>
												<Col lg={6}>
													<FormInput
														name={`goods_details[${index}].goods_length`}
														label="Length"
														labelCol={{ span: 8 }}
														wrapperCol={{ span: 16 }}
													>
														<CustomInput
															type="number"
															name={`goods_details[${index}].goods_length`}
															placeholder="Length in IN"
															isCaps
														/>
													</FormInput>
												</Col>
												<Col lg={6}>
													<FormInput
														name={`goods_details[${index}].goods_width`}
														label="Width"
														labelCol={{ span: 8 }}
														wrapperCol={{ span: 16 }}
													>
														<CustomInput
															type="number"
															name={`goods_details[${index}].goods_width`}
															placeholder="Width in IN"
															isCaps
														/>
													</FormInput>
												</Col>
												<Col lg={6}>
													<FormInput
														name={`goods_details[${index}].goods_height`}
														label="Height"
														labelCol={{ span: 8 }}
														wrapperCol={{ span: 16 }}
													>
														<CustomInput
															type="number"
															name={`goods_details[${index}].goods_height`}
															placeholder="Height in IN"
															isCaps
														/>
													</FormInput>
												</Col>
												<Col lg={6}>
													<FormInput
														name={`goods_details[${index}].goods_weight`}
														label="Weight"
														labelCol={{ span: 8 }}
														wrapperCol={{ span: 16 }}
													>
														<CustomInput
															type="number"
															name={`goods_details[${index}].goods_weight`}
															placeholder="Weight in KG"
															isCaps
														/>
													</FormInput>
												</Col>
											</Row>

											<Row gutter={24} align="middle">
												<Col
													lg={24}
													style={{
														display: 'flex',
														justifyContent: 'flex-end',
														alignItems: 'center',
													}}
												>
													{index >= 0 &&
														values.goods_details.length > 1 && (
															<button
																className="button"
																type="button"
																style={{
																	border: 'none',
																	backgroundColor: 'transparent',
																	marginTop: '10px',
																	cursor: 'pointer',
																}}
																onClick={() => {
																	remove(index);
																}}
															>
																<MinusCircleOutlined
																	style={{ fontSize: '16px' }}
																/>
															</button>
														)}
												</Col>
											</Row>
											<div
												style={{
													display: 'flex',
													justifyContent: 'center',
												}}
											>
												<button
													type="button"
													style={{
														border: '1px solid #585858',
														background: 'white',
														padding: '2px 8px',
														borderRadius: '2px',
														cursor: 'pointer',
													}}
													onClick={() => {
														console.log(values);
														push({
															goods_description: '',
															goods_quantity: '',
															goods_uom: '',
															goods_length: '',
															goods_width: '',
															goods_height: '',
															goods_weight: '',
														});
														console.log(values);
													}}
												>
													Add Goods
												</button>
											</div>
										</Box>
									</Col>
								</Row>
							))}
						</>
					)}
				/>
			</Box>
		),
		({ values, errors, setFieldValue }) => (
			<Box padding="1.5rem 2rem" background="#fff">
				{values.trip_type === 'adhoc' && (
					<>
						<Box backgroundColor="#f5f5f5" padding="1.5rem"></Box>

						<Box border="1px solid #ccc" padding="34px">
							<FilesUploadS3
								entity="trip"
								successCallBack={handleRequirementProofFileUpload}
								size={5120000}
								name="Requirement Proof *"
								fileformates={pdfimgformates}
								filetypetoShow={pdfimgfiletypetoShow}
							/>
							<Box backgroundColor="#fff" padding="1.5rem"></Box>
							{requirementInfoFilesList && (
								<ImageView
									entity="trip"
									files={formData?.info?.requirement_proof}
									name="Requirement Proof"
								/>
							)}
						</Box>
						{errors.requirement_proof && (
							<ErrorMessageBox>{errors.requirement_proof}</ErrorMessageBox>
						)}
					</>
				)}
				<FieldArray
					name="toll_info"
					render={(arrayHelpers) => (
						<div>
							{values.toll_info?.map((rowData, index) => (
								<BoxSpace key={rowData?.id}>
									<Row gutter={16} justify="end">
										{index > 0 && (
											<CancelButton
												onClick={() => addRemoveToll(arrayHelpers, index)}
												type="button"
												icon={<PoweroffOutlined />}
											>
												{index === 0
													? 'Add more Billing Address'
													: 'Remove'}
											</CancelButton>
										)}
									</Row>
									<Row gutter={16} justify="space-between">
										<Col lg={12}>
											<FormInput
												name={`toll_info[${index}].amount`}
												label="Toll Amount"
											>
												<CustomInput name={`toll_info[${index}].amount`} />
											</FormInput>
											<Box border="1px solid #ccc" padding="34px">
												<FilesUploadS3
													entity="trip"
													successCallBack={handleTollInfoFileUpload}
													extraParams={[index, setFieldValue]}
													name="Toll Info "
													size={5120000}
													fileformates={pdfimgformates}
													filetypetoShow={pdfimgfiletypetoShow}
												/>
												<Box padding="1.5rem"></Box>

												{isEditMode && (
													<ImageView
														entity="trip"
														files={
															isEditMode
																? formData?.toll_info[index]
																		?.toll_doc
																: []
														}
														name="Toll Info "
													/>
												)}
											</Box>
										</Col>
										<Col lg={12}>
											<Row></Row>
											{index === 0 && (
												<ActionAddButton
													onClick={() =>
														addRemoveToll(arrayHelpers, index)
													}
													icon={<PoweroffOutlined />}
													type="button"
												>
													{index === 0
														? '+ Add more Toll Info'
														: 'Remove'}
												</ActionAddButton>
											)}
										</Col>
									</Row>
								</BoxSpace>
							))}
						</div>
					)}
				/>
				<BoxMod></BoxMod>
				<Box border="1px solid #ccc" padding="34px">
					<FilesUploadS3
						entity="trip"
						successCallBack={handleOdometerStartFileUpload}
						name="Odometer Start"
						size={5120000}
						fileformates={pdfimgformates}
						filetypetoShow={pdfimgfiletypetoShow}
					/>
					<Box backgroundColor="#fff" padding="1.5rem"></Box>
					{odometerStartFilesList && (
						<ImageView
							entity="trip"
							files={formData?.trip_documents?.odometer_start}
							name="Odometer Start"
						/>
					)}
				</Box>
				<BoxMod></BoxMod>
				<Box border="1px solid #ccc" padding="34px">
					<FilesUploadS3
						entity="trip"
						successCallBack={handleOdometerEndFileUpload}
						name="Odometer End"
						size={5120000}
						fileformates={pdfimgformates}
						filetypetoShow={pdfimgfiletypetoShow}
					/>
					<Box backgroundColor="#fff" padding="1.5rem"></Box>
					{odometerEndFilesList && (
						<ImageView
							entity="trip"
							files={formData?.trip_documents?.odometer_end}
							name="Odometer End"
						/>
					)}
				</Box>
				<BoxMod></BoxMod>
				<Box border="1px solid #ccc" padding="34px">
					<FilesUploadS3
						entity="trip"
						successCallBack={handleTripBreakdownFileUpload}
						name="Trip Breakdown "
						size={5120000}
						fileformates={pdfimgformates}
						filetypetoShow={pdfimgfiletypetoShow}
					/>
					<Box backgroundColor="#fff" padding="1.5rem"></Box>
					{tripBreakdownFilesList && (
						<ImageView
							entity="trip"
							files={formData?.trip_documents?.trip_breakdown}
							name="Trip Breakdown "
						/>
					)}
				</Box>
			</Box>
		),
	];
	const getApprovalStatus = (trip_approval_status) =>
		!!(trip_approval_status === 1 || trip_approval_status === 4 || trip_approval_status === 5);

	function handleEdit() {
		setEditMode(!editMode);
	}
	const handleNext = async (tripType, validateForm, setTouched, errors, is_inter_city) => {
		// For intra_city, validate but skip a step
		if (!((cityType === 'inter_city' || is_inter_city) && tripType === 'adhoc')) {
			const validationErrors = await validateForm();
			console.log(validationErrors);
			if (Object.keys(validationErrors).length === 0) {
				return setStep((prev) => prev + 2);
			} else {
				const allTouchedFields = {};

				Object.keys(validationErrors).forEach((field) => {
					allTouchedFields[field] = true;
				});

				if (validationErrors.client_reference_numbers) {
					if (Array.isArray(validationErrors.client_reference_numbers)) {
						validationErrors.client_reference_numbers.forEach((_, index) => {
							allTouchedFields[`client_reference_numbers[${index}]`] = true;
						});
					} else {
						allTouchedFields['client_reference_numbers[0]'] = true;
					}
				}

				setTouched(allTouchedFields);
				return false;
			}
		}

		// For regular steps
		try {
			const validationErrors = await validateForm();
			console.log(validationErrors);
			if (Object.keys(validationErrors).length === 0) {
				return setStep((prev) => prev + 1);
			} else {
				const allTouchedFields = {};

				Object.keys(validationErrors).forEach((field) => {
					allTouchedFields[field] = true;
				});

				if (validationErrors.client_reference_numbers) {
					if (Array.isArray(validationErrors.client_reference_numbers)) {
						validationErrors.client_reference_numbers.forEach((_, index) => {
							allTouchedFields[`client_reference_numbers[${index}]`] = true;
						});
					} else {
						allTouchedFields['client_reference_numbers[0]'] = true;
					}
				}

				setTouched(allTouchedFields);
				return false;
			}
		} catch (err) {
			console.error('Validation error:', err);
			return false;
		}
	};
	const handlePrev = (tripType, is_inter_city) => {
		if (cityType === 'intra_city' || !is_inter_city || tripType === 'regular') {
			return setStep((prev) => prev - 2);
		}
		return setStep((prev) => prev - 1);
	};
	console.log('edit', editMode);
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={stepFormSchema[step]}
			onSubmit={handleSubmit}
			enableReinitialize
			innerRef={formRef}
		>
			{({ validateForm, setTouched, values, errors, setFieldValue, isValid, dirty }) => {
				return (
					<Box style={{ minHeight: 'calc(100vh - 110px - 24px)' }}>
						{isCreate && !cityType && (
							<div style={{ color: 'red', padding: '14px 0' }}>
								Route City Type is required
							</div>
						)}
						{!isEditMode &&
							ProjectAdhocFlag === true &&
							values?.trip_type === 'adhoc' && (
								<DisplayAhcdMsg>
									You can create/edit a trip but need approval to create a bill
									<div>
										{' '}
										Permission is required from the Head of Logistics to run
										Adhoc Trip for this project
									</div>
								</DisplayAhcdMsg>
							)}
						{values?.trip_type === 'adhoc' &&
							values?.trip_approval_status === 2 &&
							isEditMode && (
								<Box>
									<DisplayAhcdMsg>
										You can create/edit a trip but need approval to create a
										bill
										<div>
											{' '}
											Permission is required from the Head of Logistics to run
											Adhoc Trip for this project
										</div>
									</DisplayAhcdMsg>
									<Box style={apps}>
										<Flex>
											<SVG.APprovedICons />
											<span style={approvedS}>
												{' '}
												Adhoc Trip is Approved
											</span>{' '}
										</Flex>
										{values?.audited_by_name}
										<Box>
											{' '}
											<br />{' '}
										</Box>
										<Text overFlow="hidden">
											{getLocalDate(values?.audited_at)}{' '}
											{getLocalTime(values?.audited_at)}
										</Text>
									</Box>
								</Box>
							)}
						{values?.trip_type === 'adhoc' &&
							values?.trip_approval_status === 3 &&
							isEditMode && (
								<Box>
									<DisplayAhcdMsg>
										You can create/edit a trip but need approval to create a
										bill
										<div>
											{' '}
											Permission is required from the Head of Logistics to run
											Adhoc Trip for this project
										</div>
									</DisplayAhcdMsg>
									<Box style={rejectapps}>
										<Flex>
											<SVG.RejectIConsAPp />
											<span style={rejectedS}>
												{' '}
												Adhoc Trip is Rejected
											</span>{' '}
										</Flex>
										{values?.audited_by_name}
										<Box>
											{' '}
											<br />{' '}
										</Box>
										<Text overFlow="hidden">
											{getLocalDate(values?.audited_at)}{' '}
											{getLocalTime(values?.audited_at)}
										</Text>
										{values?.audit_remarks && (
											<Text overFlow="hidden" style={overlaps}>
												<span style={{ color: '#ccc' }}>
													{' '}
													Reject reason :{' '}
												</span>
												{values?.audit_remarks}
											</Text>
										)}
									</Box>
								</Box>
							)}
						{values?.trip_type === 'adhoc' &&
							values?.trip_approval_status === 1 &&
							isEditMode && (
								<Box>
									<DisplayAhcdMsg>
										You can create/edit a trip but need approval to create a
										bill
										<div>
											{' '}
											Permission is required from the Head of Logistics to run
											Adhoc Trip for this project
										</div>
									</DisplayAhcdMsg>
									<Box style={appsPending}>
										<Flex>
											<SVG.WarningIconApps />
											<span style={approvedSpending}>
												{' '}
												Approval is Pending
											</span>{' '}
										</Flex>
									</Box>
								</Box>
							)}
						{values?.trip_type === 'adhoc' &&
							values?.trip_approval_status === 4 &&
							values?.trip_status === 3 &&
							isEditMode && (
								<Box>
									<DisplayAhcdMsg>
										You can create/edit a trip but need approval to create a
										bill
										<div>
											{' '}
											Permission is required from the Head of Logistics to run
											Adhoc Trip for this project
										</div>
									</DisplayAhcdMsg>
									<Box style={Autoapps}>
										<Flex>
											<SVG.APprovedICons />
											<span style={approvedS}>
												{' '}
												Adhoc Trip is Auto Approved
											</span>{' '}
										</Flex>
										<Box>
											{' '}
											<br />{' '}
										</Box>
									</Box>
								</Box>
							)}

						{values?.is_vendor_billed && (
							<DisplayBIlledMsg>
								This trip is already billed, you can not edit this trip. Please
								contact your reporting manager
							</DisplayBIlledMsg>
						)}
						<Form
							style={{ marginBottom: '70px' }}
							className={!isCreate || !cityType ? 'disabled-div' : undefined}
						>
							{stepFormFields[step]({ values, errors, setFieldValue })}

							<FormButtonContainer>
								{step == 0 && (
									<FormCancelButton type="button" onClick={() => navigate(-1)}>
										Cancel
									</FormCancelButton>
								)}
								{step > 0 && (
									<FormCancelButton
										type="button"
										onClick={() =>
											handlePrev(values?.trip_type, values?.is_inter_city)
										}
									>
										Previous
									</FormCancelButton>
								)}

								{step < stepFormFields.length - 1 && (
									<FormPrimaryButton
										type="button"
										onClick={() => {
											if (step === 1) {
												const touchedFields = {};
												touchedFields.client_reference_numbers = true;
												touchedFields['client_reference_numbers[0]'] = true;
												setTouched(touchedFields, true);
											}
											handleNext(
												values?.trip_type,
												validateForm,
												setTouched,
												values?.is_inter_city
											);
										}}
									>
										Next
									</FormPrimaryButton>
								)}
								{step === stepFormFields.length - 1 && (
									<FormPrimaryButton
										type="submit"
										disabled={!editMode && !isCreate}
									>
										{isEditMode ? 'Update' : 'Submit'}
									</FormPrimaryButton>
								)}
							</FormButtonContainer>
						</Form>
					</Box>
				);
			}}
		</Formik>
	);
}

TripForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	cities: PropTypes.array,
	tripData: PropTypes.array,
	trip_reason: PropTypes.array,
};
